import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
import Login from "../interfaces/Login.interface";
import Usuario from "../interfaces/Usuario.interface";

const url = `${ApiConfig.URLBase}/usuarios`

const listar = async (texto: string): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar`,
        metodo: "POST",
        data: { texto }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const listarStatus = async (): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/estatus`,
        metodo: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const login = async (login: Login): Promise<Response> => {

    const request: Request = {
        url: `${url}/login`,
        metodo: "POST",
        data: { username: login.username, password: login.password }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const guardar = async (usuario: Usuario): Promise<Response> => {

    const request: Request = {
        url: `${url}/guardar`,
        metodo: "POST",
        data: { usuario }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const UsuarioService = {
    listar,
    listarStatus,
    login,
    guardar,
};

export default UsuarioService;